<template>
  <div id="app">
    <!-- Do not change order! -->
    <dev-panel v-if="debugMode" />
    <the-lock v-show="appIsLocked" />
    <template v-if="userIsLogged">
      <snackbar />
      <lm-sidenav />
      <modals-controller />
      <the-filter-list />
      <reload-warning />
    </template>
    <main-header />
    <main-alert />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import DevPanel from '@/components/common/DevPanel'
import ReloadWarning from '@/components/common/ReloadWarning'
import TheFilterList from '@/components/common/TheFilterList'
/* global localStorage */
import {mapGetters} from 'vuex'
import EventHub, {newAlert} from './lib/eventHub'
import {
  Events,
  LocalStorage,
  Alert as AlertType,
  AlertMessages
} from './lib/definitions'
import TheLock from '@/components/common/TheLock'
import MainAlert from '@/components/common/MainAlert'
import MainHeader from '@/components/common/MainHeader.vue'
import LmSidenav from '@/components/common/Sidenav.vue'
import ModalsController from '@/components/modals/ModalsController'
import Snackbar from '@/components/common/Snackbar'

export default {
  name: 'App',
  components: {
    ReloadWarning,
    MainAlert,
    TheFilterList,
    DevPanel,
    Snackbar,
    ModalsController,
    MainHeader,
    LmSidenav,
    TheLock
  },
  data() {
    return {
      appIsLocked: false,
      debugMode: process.env.VUE_APP_DEBUG_MODE === 'on'
    }
  },
  computed: mapGetters(['userIsLogged', 'hideScrollbar', 'email']),
  watch: {
    hideScrollbar(b) {
      const html = document.documentElement.classList
      b ? html.add('no-scroll') : html.remove('no-scroll')
    }
  },
  created() {
    EventHub.on(Events.LOCK_APP, lock => {
      this.appIsLocked = lock
    })
  },
  mounted() {
    let pendingMessage = localStorage.getItem(LocalStorage.PENDING_MESSAGE)
    if (pendingMessage) {
      newAlert(pendingMessage, AlertType.ERROR, false)
      localStorage.removeItem(LocalStorage.PENDING_MESSAGE)
    }
    // Check connection status
    window.addEventListener('online', () => {
      newAlert(AlertMessages.CONNECTION_REESTABLISHED, AlertType.SUCCESS)
    })
    window.addEventListener('offline', () => {
      newAlert(AlertMessages.CONNECTION_LOST, AlertType.WARNING, false)
    })
    const params = this.$route.query
    // New signup
    if (params.newAccount) {
      if (this.userIsLogged) {
        const msg = AlertMessages.NEW_ACCOUNT_BUT_LOGGED_IN.replace(
          '##user##',
          this.email
        )
        newAlert(msg, AlertType.WARNING, false)
      } else {
        newAlert(AlertMessages.NEW_ACCOUNT, AlertType.SUCCESS, false)
      }
    }
    // Email verification
    if (params.email && params.success && params.message) {
      newAlert(AlertMessages.EMAIL_VERIFICATION, AlertType.SUCCESS, false)
    }
  }
}
</script>
